import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { RxCross2 } from 'react-icons/rx';
import { OverlayDialog, OverlayHead, OverlayScrim } from './ui.styles';

export default function OverlayModal({
  title,
  subtitle,
  onClose,
  children,
  width = 480,
  noHead = false,
  isCloseAble = true,
  /** `drawer` = right panel (longer forms); `center` = modal dialog (prompts / confirms) */
  placement = 'drawer',
}) {
  useEffect(() => {
    const onKey = e => {
      if (e.key === 'Escape' && isCloseAble) onClose?.();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev || 'auto';
    };
  }, [onClose, isCloseAble]);

  const modalRoot = typeof document !== 'undefined' ? document.getElementById('modal-root') : null;

  const node = (
    <OverlayScrim
      $placement={placement}
      onClick={() => {
        if (isCloseAble) onClose?.();
      }}
      role="presentation">
      <OverlayDialog
        $width={width}
        $placement={placement}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        tabIndex={-1}>
        {!noHead && (title || isCloseAble) ? (
          <OverlayHead>
            <div className="text-col">
              {title ? <strong className="title">{title}</strong> : null}
              {subtitle ? <p className="subtitle">{subtitle}</p> : null}
            </div>
            {isCloseAble ? (
              <button type="button" className="closer" onClick={onClose} aria-label="Close" tabIndex={0}>
                <RxCross2 />
              </button>
            ) : null}
          </OverlayHead>
        ) : null}
        {children}
      </OverlayDialog>
    </OverlayScrim>
  );

  if (modalRoot) return createPortal(node, modalRoot);
  return node;
}
